import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { EventsCalendar } from '../types';

interface EventsCalendarList extends BaseResponse {
  data: {
    items: EventsCalendar.EventsCalendarItem[];
  }
}

export class EventsCalendarService extends BaseApiService {
  private readonly base_path = 'calendar';

  async get_calendar(filters: Filters): Promise<EventsCalendarList> {
    const payload = filters;

    const { data } = await this.http_client.get<EventsCalendarList>(this.base_path, {
      params: {
        filters: payload.filters,
      },
    });

    return data;
  }

  async statistics_sent(event: EventsCalendar.StatisticEvent) {
    const url = `${this.base_path}`;

    await this.http_client.post<Response<null>>(url, event);
  }
}
